import React from "react";

export default function BenchmarkSkeleton() {
  return (
    <div className="p-6 space-y-8 animate-pulse">
      {/* Header */}
      <div className="h-10 w-80 bg-gray-200 rounded mb-4" />

      {/* Filter Bar */}
      <div className="h-12 w-full bg-gray-100 rounded mb-4" />

      {/* Metric Cards */}
      <div className="grid grid-cols-4 gap-4 mb-4">
        {[...Array(8)].map((_, i) => (
          <div key={i} className="bg-gray-100 rounded-lg h-20 w-full" />
        ))}
      </div>

      {/* Chart Metric Selector */}
      <div className="mb-4 flex items-center gap-2">
        <div className="h-6 w-32 bg-gray-100 rounded" />
        <div className="h-8 w-40 bg-gray-200 rounded" />
      </div>

      {/* Charts */}
      <div className="flex gap-6 mb-8">
        <div className="flex-1">
          <div className="h-6 w-32 bg-gray-100 rounded mb-2" /> {/* Chart heading */}
          <div className="bg-gray-200 rounded-xl h-[300px] w-full" />
        </div>
        <div className="flex-1">
          <div className="h-6 w-32 bg-gray-100 rounded mb-2" /> {/* Chart heading */}
          <div className="bg-gray-200 rounded-xl h-[300px] w-full" />
        </div>
      </div>

      {/* Deviation Table Skeleton */}
      <div className="bg-white rounded-lg shadow p-4 mb-2">
        <div className="h-8 bg-gray-200 rounded w-64 mb-4" /> {/* Table title */}
        {/* Table header row */}
        <div className="flex gap-4 mb-2">
          {[...Array(10)].map((_, i) => (
            <div key={i} className="h-6 w-24 bg-gray-100 rounded" />
          ))}
        </div>
        {/* Table rows */}
        <div className="space-y-2">
          {[...Array(6)].map((_, rowIdx) => (
            <div key={rowIdx} className="flex gap-4">
              {[...Array(10)].map((_, colIdx) => (
                <div key={colIdx} className="h-6 w-24 bg-gray-200 rounded" />
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
} 